import type {Thread} from '../../agentChat/store/thread';
import type {
  ThreadResponse,
  TurnResponse,
} from '../../aria/client/WbAgentClient';
import {decodePromptForThreadTitle} from './utils';

/**
 * parseTurnTitle extracts a turn's stored title and prompt excerpt as the
 * (title, promptSnippet) pair used by the agent-chat store.
 */
export function parseTurnTitle(turn: Pick<TurnResponse, 'user_prompt'>): {
  title: string | null;
  promptSnippet: string | null;
} {
  const snippet = decodePromptForThreadTitle(turn.user_prompt ?? '');
  return {
    title: null,
    promptSnippet: snippet || null,
  };
}

/**
 * parseThreadTitle extracts a thread's stored title and server-derived prompt
 * preview as the (title, promptSnippet) pair used by the agent-chat store.
 */
export function parseThreadTitle(
  thread: Pick<ThreadResponse, 'title' | 'prompt_preview'>
): {title: string | null; promptSnippet: string | null} {
  const stored = thread.title?.trim() ?? '';
  const snippet = thread.prompt_preview?.trim() ?? '';
  return {
    title: stored || null,
    promptSnippet: snippet || null,
  };
}

/**
 * resolveThreadTitle returns the title to render for a chat history row.
 * Falls back through the stored title, the prompt snippet, and a generic
 * "Untitled conversation" label when both are empty.
 */
export function resolveThreadTitle(thread: Thread): string {
  return (
    thread.title?.trim() || thread.promptSnippet || 'Untitled conversation'
  );
}
